/*
  input format: 79062212452
  output format: +7 906 221 24 52
*/
export const toInternationalFormat = (phoneNumber: string): string => (
  phoneNumber.replace(/(7)(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 $2 $3 $4 $5')
);
